

import React, { Component } from 'react';
import OpenFolderIcon from 'Components/icons/OpenFolderIcon/OpenFolderIcon.jsx';
export class AgFolderIcon extends Component {
    constructor(props) {
        super(props);
        this.invokeParentMethod = this.invokeParentMethod.bind(this);
       
    }

    render() {
        return (
            <span>
                <OpenFolderIcon onClick = {this.invokeParentMethod} height={20} width={20}  color = "#007dc3" />
            </span>
        );
    }

    invokeParentMethod(rowIndex,keySeqKey) {
        this.props && this.props.context && this.props.context.componentParent && this.props.context.componentParent.props && this.props.context.componentParent.props.rowActionClick && this.props.context.componentParent.props.rowActionClick(this.props.node.rowIndex, 'OPEN_CASE');
    };
}
export default AgFolderIcon;